module.exports = __webpack_public_path__ + "img/hotel.4ee745a2.jpg";